import Vue from 'vue';
import { MutationTree } from 'vuex';
import { CommentState } from './state';

const mutations: MutationTree<CommentState> = {
  SET_COMMENTS(state, entities: CommentState) {
    if (!entities.comments) return;
    Object.values(entities.comments).forEach((comment) => {
      Vue.set(state.comments, comment.id.toString(), {
        ...state.comments[comment.id],
        ...comment,
      });
    });
  },

  SET_UPDATED_COMMENT_SCORE(state, payload: { commentId: number; score: number }) {
    if (!payload || !payload.commentId || payload.score === null) return undefined;

    const { commentId, score } = payload;

    Vue.set(state.comments, commentId, {
      ...state.comments[commentId],
      score,
    });

    return true;
  },

  /**
   * This mutations is responsible to change the Score Updating Status for a particular comment.
   * This is used to know when a comment is being updated. That way, we can make changes in the UI
   * for a particular comment.
   * @param state
   * @param {commentId, updating} payload The commentId and the status that should be applied to it (updating: true/false)
   */
  CHANGE_COMMENT_SCORE_UPDATING_STATUS(state, payload: { commentId: string; updating: boolean }) {
    const { commentId, updating } = payload;
    Vue.set(state.isUpdatingCommentScore, commentId, updating);
  },
};

export default mutations;
